<button climbButton
        size="md"
        (click)="openWorkgroupModal()"
        class="workgroup-switch-button">
    Workgroup: {{ workgroupName }}
</button>
